module.exports = __webpack_public_path__ + "static/alchemy-ae34094c9efade777b877912f5407d46.png";